<template>
    <div class="partner" :style="{backgroundColor: bgColor}">
        <div class="partner-content">
            <Carousel class="list" arrows autoplay :dots="false">
                <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow law"><i></i></div>
                <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow raw"><i></i></div>
                <div class="item" v-for="(item,index) in partnerList" :key="index">
                    <div class="o" v-for="(o,i) in item" :key="i">
                        <a v-link="o.link" v-if="o.link">
                            <img :src='o.image'>
                        </a>
                        <a v-else href="javascript:;">
                            <img :src='o.image'>
                        </a>
                    </div>
                </div>
            </Carousel>
        </div>
    </div>
</template>
<script>
import {Carousel} from 'ant-design-vue'
import {chunk} from 'lodash'
export default {
    components:{Carousel},
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        },
        size: {
            type: Number,
            default: 3
        },
        bgColor: {
            type: String,
            default: '#ffffff'
        }
    },
    computed:{
        partnerList(){
            return chunk(this.list,this.size);
        }
    }
}
</script>
<style lang="scss" scoped>
.partner {
    width: 100%;
    background:#fff;
    padding-top:35px;
    padding-bottom: 65px;

    .partner-content {
        @include Width;
        // width:50%;
        margin: 0 auto;
    }
    .list {
        width: 1033px;
        margin: 0 auto;
        .item {
            display: flex !important;
            flex-wrap:wrap;
            @include Width;
            .o {
                height: auto;
                width: 33.33%;
                padding-right: 20px;
                @include Flex;
                align-items: center;
                justify-content: center;
                // background-color: #ffffff;
                // box-shadow: 0px 2px 10px 0px 
                //     rgba(12, 13, 9, 0.11);
                // border-radius: 10px;
                overflow: hidden;

                .op{
                    height:278px;
                    width: 100%;
                    box-shadow: 0px 2px 10px 0px 
                    rgba(12, 13, 9, 0.11);
                border-radius: 10px;
                }
                a {
                    display: block;
                    @include Flex;
                    width: 100%;
                    height: auto;
                    justify-content: center;
                    align-items: center;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    box-shadow: 0px 2px 10px 0px 
                    rgba(12, 13, 9, 0.11);
                border-radius: 10px;

                    img{
                        width:100%;
                    }


                    &:hover{
                        transform: scale(1.05);
                        transition: transform 1s ease-out;
                    }
                }
            }
        }
        .custom-slick-arrow {
            width: 66px;
            height: 66px;
            margin-top: -33px;
            i {
                display: inline-block;
                width: 66px;
                height: 66px;
                background: url('~@assets/images/home/partner_arrow.svg') no-repeat;
                background-size: 100%;
            }
            &.law{
                left: -68px;
                z-index: 1;
            }
            &.raw {
                right: -68px;
                i {
                    transform: rotate(180deg);
                }
            }
        }
    }
}
</style>

